import styled from 'styled-components'
import fadeIn from '../../styles/animations/fadeIn'
import ripple from '../../styles/animations/ripple'

export const Container = styled.div`
  ${fadeIn};
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 15px;
`

export const Form = styled.form`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 15px;
`
export const Title = styled.div`
  font-size: 45px;
  color: ${({ theme }) => theme.colors.title};
`
export const ContentCenter = styled.div`
  display: flex;
  margin-top: 15px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img {
    ${ripple}
    cursor: pointer;
  }
`

export const Actions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 15px;
  span {
    ${ripple}
    cursor: pointer;
  }
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
`

export const Row = styled.div<{
  justify?: string
  gap?: number
  align?: string
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ gap }) => gap || 0}px;

  justify-content: ${({ justify }) => justify || 'flex-start'};
`
